/**
 * Styles for color picker box  
 * @example ccfColorPickerStyles()
 */
const ccfColorPickerStyles = () => ({
  ColorPickerContainer: {
    maxHeight: '24px',
  },
  ColorButton: {
    width: '18px',
    height: '18px',
    border: '1px solid #222',
    borderRadius: '3px',
    margin: '2px',
    cursor: 'pointer',
  },
  ColorResetButton: {
    padding: '5px 0',
    cursor: 'pointer',
    fontSize: '0.75rem',
    width: '100%',
  },
  ColorButtonContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    justifyItems: 'center',
    padding: '5px',
    borderTop: '1px solid #d5d5d5',
  },
  ColorPickerPopover: {
    backgroundColor: 'white',
    width: '120px',
    border: '1px solid #d5d5d5',
  },
})

export default ccfColorPickerStyles;

